'use client';

import { useSetAtom } from 'jotai';
import React, { SyntheticEvent } from 'react';
import { ContactFormExpert } from '@sapientpro/sapientpro-data-models/src/components/shared/contact-form-expert';
import Button, { ButtonVariants } from '../../components/Button';
import contactModalTriggerButton from '../../store/contactForm';
import styles from './Service.module.scss';
import useContactExpert from '../../useContactExpert';
import { GAEmit, GAEvents } from '../../gtagHelper';

interface IServiceContactUsButtonProps {
  expert: ContactFormExpert;
  text?: string;
}

function ServicesContactUsButton({ expert, text }: IServiceContactUsButtonProps) {
  const setContactsModalTrigger = useSetAtom(contactModalTriggerButton);
  const displayedText = text || 'Get expert advice';

  useContactExpert(expert);
  const showContactModal = (e: SyntheticEvent) => {
    setContactsModalTrigger(`${(e.target as HTMLElement).innerText} | Service page hero section`);
    GAEmit(GAEvents.firstBlockClick);
  };

  return (
    <Button
      className={styles.hero__button}
      variant={ButtonVariants.PRIMARY}
      icon={(
        <svg>
          <use
            xlinkHref='/media/icon-nest.svg#iconNest'
            href='/media/icon-nest.svg#iconNest'
          />
        </svg>
      )}
      iconPosition='right'
      iconSize={{ width: 24, height: 24 }}
      onClick={showContactModal}
    >
      {displayedText}
    </Button>
  );
}

export default ServicesContactUsButton;
